import { dbDate } from "@caredna-marlin/utils/dates";
import { Badge } from "@mui/material";
import { DateCalendar, PickersDay, PickersDayProps } from "@mui/x-date-pickers";

type Props = {
  value: Date | null;
  onChange: (value: Date) => void;
  dateBadges: { [date: string]: string };
};

export default function SchedulerMonthCalendar({
  value,
  onChange,
  dateBadges,
}: Props) {
  return (
    <DateCalendar
      views={["day"]}
      view="day"
      showDaysOutsideCurrentMonth
      fixedWeekNumber={6}
      value={value}
      onChange={(value) => onChange(value)}
      slots={{ day: CustomDay }}
      slotProps={{
        day: {
          // @ts-ignore
          dateBadges: dateBadges,
        },
      }}
    />
  );
}

function CustomDay(
  props: PickersDayProps<Date> & { dateBadges?: { [date: string]: string } }
) {
  const { dateBadges = {}, day, outsideCurrentMonth, ...other } = props;
  const color = dateBadges[dbDate(props.day)];

  // const isSelected = !props.outsideCurrentMonth && color;
  const isSelected = color;

  return (
    <Badge
      invisible={!isSelected}
      key={props.day.toString()}
      overlap="circular"
      variant="dot"
      // @ts-ignore
      color={color || "default"}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <PickersDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        sx={{
          fontSize: "1.1rem",
        }}
      />
    </Badge>
  );
}
